import axios from 'api/axios';

export const createTemplate = async (data: KIARA.TemplateRequest) =>
    axios(
        {
            url: 'me/template',
            data
        },
        true
    );

export const getTemplates = async () => axios<KIARA.TemplateResponse[]>({ url: 'me/template', method: 'GET' }, true);

export const getTemplate = async (id: string) =>
    axios<KIARA.TemplateResponse>({ url: `me/template/${id}`, method: 'GET' }, true);

export const updateTemplate = async (id: string, data: KIARA.TemplateRequest) =>
    axios<KIARA.SuccessAnswer>({ url: `me/template/${id}`, method: 'PATCH', data }, true);

export const deleteTemplate = async (id: string) =>
    axios<KIARA.SuccessAnswer>({ url: `me/template/${id}`, method: 'DELETE' }, true);
